import { render, staticRenderFns } from "./marqueeNoticeDepricated.vue?vue&type=template&id=6a3e4162&scoped=true&"
import script from "./marqueeNoticeDepricated.vue?vue&type=script&lang=js&"
export * from "./marqueeNoticeDepricated.vue?vue&type=script&lang=js&"
import style0 from "./marqueeNoticeDepricated.vue?vue&type=style&index=0&id=6a3e4162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3e4162",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
